import { Button, CircularProgress, DialogActions } from "@mui/material";
import "./CustomModalActionButton.scss";
import { ICustomModalActionButton } from "./CustomModalActionButton";

const CustomModalActionButton = ({
  handleClose,
  cancelText,
  saveText,
  formId,
  onConfirm,
  className,
  isLoading = false,
  isCancel = false,
  loadingText
}: ICustomModalActionButton) => {
  return (
    <DialogActions className={className}>
      {cancelText && (
        <Button onClick={handleClose} variant="outlined" className="btn-cancel" style={{ textTransform: "capitalize", fontWeight: 400 }}>
          {cancelText}
        </Button>
      )}
      {saveText && (
        <Button
          style={{ textTransform: "capitalize", fontWeight: 400 }}
          type="submit"
          onClick={onConfirm}
          form={formId}
          variant="contained"
          className={isCancel ? "btn-red" : "btn-submit"}
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : null}
        >
          {isLoading ? (loadingText || "Deleting...") : saveText}
        </Button>
      )}
    </DialogActions>
  );
};

export default CustomModalActionButton;
